import { Content } from "@/ui";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { getGlobal } from "@/functions/getGlobal";
import { getSimplePagesStaticProps } from "@/functions/getSimplePagesStaticProps";
import { getDynamicPageStaticProps } from "@/functions/getDynamicPageStaticProps";
import useDynamicPage from "@/hooks/useDynamicPage";
import useDynamicPages from "@/hooks/useDynamicPages";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { ContentBlocks } from "@/ui/ContentBlocks";
import { getNestedRoutes } from "@/functions/getNestedRoutes";

export default function Page({ content, prefix, title, seo, canonical, data, isBuilder = false }) {
  return (
    <>
      {isBuilder ? (
        <>
          <DynamicPageSeo
            {...seo}
            title={seo?.title.length > 0 ? seo.title : title}
            canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
          />
          <ContentBlocks data={data} prefix={prefix} />
        </>
      ) : (
        <Content items={content} logoCarousel={false} />
      )}
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const url_slug = url_slugs.join("/");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const builderPage = useDynamicPage(url_slug);
  if (builderPage) {
    return getDynamicPageStaticProps({ page: builderPage, url_slug });
  }

  return getSimplePagesStaticProps({ url_slugs });
}

export async function getStaticPaths() {
  const global = getGlobal();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const builderPaths = useDynamicPages()
    .filter((i) => !["/"].includes(i.url_slug))
    .map((i) => ({ params: { url_slugs: i.url_slug.split("/") } }));

  const hardcodedExcludes = [
    "24b02341-0dfe-4022-8e64-8f29929501fb", // Careers with Medacs
    "5f185f93-a7f6-4f78-ba28-8ba33419ea3a", // Clinician Support page
    "6d2231d6-cecd-4afa-8ec7-f8872a33e720", // About us
    "6181da03-6bd5-4199-90f8-df5b0efaefb4", // Meet our team
  ];

  // const dynamicExcludes = global["_theme.simplePagesExcludeList"]?.split(",").map((i) => i.trim());

  // const combinedExcludes = [...new Set([...hardcodedExcludes, ...dynamicExcludes])];

  return {
    paths: [
      ...builderPaths,
      ...simple_pages_helper.toNestedPaths({
        exclude: hardcodedExcludes,
      }),
    ],
    fallback: true,
  };
}
